import PermissionButton from '../../permissions/PermissionButton';
import React, { useState } from 'react';
import { Input, Typography, Space, Button, message } from 'antd';
import { EditOutlined, SaveOutlined } from '@ant-design/icons';
import { changeAvoirRef } from '../../models/avoirAPI';

const { Text } = Typography;

const AvoirRefEditor = ({ refAvr, onSuccess, disabled }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedValue, setEditedValue] = useState(refAvr);
  const [isSaving, setIsSaving] = useState(false);
  
  const handleEdit = () => {
    setEditedValue(refAvr);
    setIsEditing(true);
  };

  const handleSave = async () => {
    // Validate that the prefix (letters + first digit) hasn't changed (EN, AV1, AV3, etc.)
    // Match pattern: letters followed by optional single digit (not all digits)
    const originalPrefix = refAvr.match(/^[A-Z]+\d?/)?.[0] || refAvr.substring(0, 2);
    const newPrefix = editedValue.match(/^[A-Z]+\d?/)?.[0] || editedValue.substring(0, 2);
    
    if (originalPrefix !== newPrefix) {
      message.error(`The prefix "${originalPrefix}" cannot be modified`);
      return;
    }

    // Validate that the new reference isn't empty
    if (!editedValue.trim()) {
      message.error('Reference cannot be empty');
      return;
    }

    // Call dedicated API for changing ref only (fast!)
    try {
      setIsSaving(true);
      await changeAvoirRef(refAvr, editedValue);
      message.success('Référence modifiée avec succès!');
      setIsEditing(false);
      if (onSuccess) onSuccess(editedValue);
    } catch (error) {
      message.error(`Erreur: ${error.response?.data?.message || error.message}`);
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancel = () => {
    setEditedValue(refAvr);
    setIsEditing(false);
  };

  return (
    <Space>
      {!isEditing ? (
        <>
          <Text strong style={{ fontSize: '16px' }}>{refAvr}</Text>
          {!disabled && (
            <PermissionButton permissionModule="returns" permissionAction="reference"
              type="link" 
              icon={<EditOutlined />} 
              onClick={handleEdit}
              size="small"
            />
          )}
        </>
      ) : (
        <>
          <Input
            value={editedValue}
            onChange={(e) => setEditedValue(e.target.value)}
            style={{ 
              width: 200,
              fontSize: '16px',
              fontWeight: 'bold'
            }}
            onPressEnter={handleSave}
          />
          <PermissionButton permissionModule="returns" permissionAction="reference"
            type="link" 
            icon={<SaveOutlined />} 
            onClick={handleSave}
            size="small"
            loading={isSaving}
          />
          <PermissionButton
            type="link" 
            danger 
            onClick={handleCancel}
            size="small"
          >
            Cancel
          </PermissionButton>
        </>
      )}
    </Space>
  );
};

export default AvoirRefEditor;

